import { environment as base } from "./environment.smrt";

export const environment = {
  ...base,
  production: true,
  bugsnagEnv:'Production',
  apiUrl: 'https://smrt-prd-memberPortal.azurewebsites.net/api',
  ga: 'G-CDQ0VPL5F5',
  b2cApiEndpoint: 'https://smrt-prd-memberportal.azurewebsites.net/api/**',
  b2cClientId: '6945aa30-961a-4372-afea-de88d8734825',
  b2cReadScope: 'https://ApexSMRT.onmicrosoft.com/f30fb06c-8b6b-4c7e-9d6f-e7f3c75e6e9b/MemberPortal.User',
  b2cWriteScope: 'https://ApexSMRT.onmicrosoft.com/f30fb06c-8b6b-4c7e-9d6f-e7f3c75e6e9b/MemberPortal.User',
  b2cLogoutUrl: 'https://auth.smartmonday.com.au/oidc/logout',
  b2cPolicySignIn: 'B2C_1A_MP_SIGNUP_SIGNIN',
  b2cSignInAuthority:'https://apexsmrt.b2clogin.com/apexsmrt.onmicrosoft.com/B2C_1A_MP_SIGNUP_SIGNIN',
  b2cPolicyElevatedSignIn: 'B2C_1A_FP_MP_ELEVATEDACCESS',
  b2cElevatedSignInAuthority:'https://apexsmrt.b2clogin.com/apexsmrt.onmicrosoft.com/B2C_1A_FP_MP_ELEVATEDACCESS',
  b2cPolicyAdviserElevatedSignIn: 'B2C_1A_AP_MP_ELEVATEDACCESS',
  b2cAdviserElevatedSignInAuthority:'https://apexsmrt.b2clogin.com/apexsmrt.onmicrosoft.com/B2C_1A_AP_MP_ELEVATEDACCESS',
  b2cAuthorityDomain: 'apexsmrt.b2clogin.com',
  greenIdEnv:'prod',
  greenIdCode:'Xrv-cUK-rUQ-Ab5',

};
